// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayDescriptionDescription_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDescription_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayDescriptionDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Description(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDescription_draft_graphql.node, convertFragment, props.draft);
  let descriptionIsValid = PropertyWizardFormRelay__Validators__Description.Description.useIsValid(draft.fragmentRefs);
  let description = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.description = value;
      return newrecord;
    }
  }, props.stepHasBeenTouched, draft.draftProperty.description, descriptionIsValid);
  let match = React.useState(() => draft.draftProperty.description);
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RichTextEditorField.make, {
        labelText: "Description",
        onChange: param => description.onChange(param.content),
        onBlur: param => description.onBlur(),
        initialContent: match[0],
        status: description.status
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: description.valid
      })
    ]
  });
}

let Components;

let TextInputField;

let Cell;

let Validators;

let FormUtils;

let FormControl;

let Elements;

let make = PropertyWizardRelay__Description__Description;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.FormControl = FormControl;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
